'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Carousel2 = require('../../../carousel/main/jsx/Carousel');

var _Carousel3 = _interopRequireDefault(_Carousel2);

var _clone = require('../../../../../utilities/clone');

var _clone2 = _interopRequireDefault(_clone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'offers-panels-carousel';

var SlideNumberCarousel = function (_Carousel) {
  _inherits(SlideNumberCarousel, _Carousel);

  function SlideNumberCarousel() {
    _classCallCheck(this, SlideNumberCarousel);

    return _possibleConstructorReturn(this, (SlideNumberCarousel.__proto__ || Object.getPrototypeOf(SlideNumberCarousel)).apply(this, arguments));
  }

  _createClass(SlideNumberCarousel, [{
    key: 'renderDotSelectors',
    value: function renderDotSelectors(itemsLen) {
      var className = this.props.className;
      var currentSlide = this.state.currentSlide;

      var activeSlide = currentSlide >= itemsLen ? 1 : currentSlide + 1;

      return _react2.default.createElement(
        'span',
        {
          className: className + '__slide-counter ' + ORGANISM_NAME + '__slide-counter'
        },
        activeSlide + ' / ' + itemsLen
      );
    }
  }]);

  return SlideNumberCarousel;
}(_Carousel3.default);

exports.default = SlideNumberCarousel;


SlideNumberCarousel.propTypes = (0, _clone2.default)(_Carousel3.default.propTypes);

SlideNumberCarousel.defaultProps = (0, _clone2.default)(_Carousel3.default.defaultProps);


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/panels/offer-panels/jsx/SlideNumberCarousel.js
// module id = 1127
// module chunks = 4